import { generate } from '@/utils/request';
const config = {
  prefix: '/spur/v1/{organizationId}/',
  items: [
    // 采购单列表
    { key: 'getPurchases', url: 'purchases', method: 'GET' },
    // 根据采购单号获取采购单列表
    { key: 'getByPurchaseCodeList', url: 'purchases/getByPurchaseCodeList', method: 'GET' },
    // 创建采购单
    { key: 'addPurchases', url: 'purchases', method: 'POST' },
    // 修改采购单
    { key: 'putPurchases', url: 'purchases', method: 'PUT' },
    // 删除采购单
    { key: 'deletePurchases', url: 'purchases/batch', method: 'DELETE' },
    // 采购单明细
    { key: 'getPurchasesDetail', url: 'purchases/detail', method: 'GET' },
    // 反审采购单
    { key: 'antiAuditPurchases', url: 'purchases/anti-audit', method: 'PATCH' },
    // 审核采购单
    { key: 'auditPurchases', url: 'purchases/audit', method: 'PATCH' },
    // 取消采购单
    { key: 'cancelPurchases', url: 'purchases/cancel', method: 'PATCH' },
    // 采购单单确定入库
    { key: 'finishPurchases', url: 'purchases/finish', method: 'PATCH' },
    // 采购单导出
    { key: 'reportPurchases', url: 'purchases/report', method: 'GET', rType: 2 },
    // 采购单导入
    { key: 'purchaseGoodsImport', url: 'purchases/getGoodsSku', method: 'POST'},
    // 采购入库单导入
    { key: 'purchaseOrderGoodsImport', url: 'purchases/getPurchaseOrderGoodsSku', method: 'POST'},
    // 采购单推送SAP
    { key: 'purchasePushSAP', url: 'purchases/pushSAP', method: 'POST'},
    // 废弃采购单
    { key: 'purchaseCancel', url: 'purchases/cancel', method: 'PATCH'},
    // 完成采购
    { key: 'purchaseFinish', url: 'purchases/finish', method: 'GET'},
    // 采购单生产（状态）
    { key: 'purchaseChangeStatus', url: 'purchases/change_status', method: 'PATCH'},
    // 获取sku采购成本列表
    { key: 'getSkuPurchaseCostList', url: 'purchases/getSkuPurchaseCostList', method: 'POST' },
    // 获取返单及时率列表
    { key: 'getSkuPurchaseReturnList', url: 'predictionReturn/pagePredictionReturnList', method: 'POST' },
    // 预测记录导出
    { key: 'exportPredictionReturn', url: 'predictionReturn/export', method: 'POST', rType: 2},
    // 修改采购商品状态
    { key: 'updatePurchaseGoodsStatus', url: 'purchases/updatePurchaseGoodsStatus', method: 'POST' },
    // 报价单转采购单
    { key: 'quotationApplyToPurchase', url: 'purchases/quotationApplyToPurchase', method: 'POST' },
    // csg入库配置列表 GET /v1/{organizationId}/date/disable/config            ==> 马光浩
    { key: 'getCsgPurchaseOrderTimeList', url: 'date/disable/config', method: 'GET' },
    // csg创建采购配置 POST /v1/{organizationId}/date/disable/config           ==> 马光浩
    { key: 'addCsgPurchaseOrderTimeList', url: 'date/disable/config', method: 'POST' },
    // csg修改采购配置 PUT /v1/{organizationId}/date/disable/config            ==> 马光浩
    { key: 'putCsgPurchaseOrderTimeList', url: 'date/disable/config', method: 'PUT' },
    // csg删除采购配置 DELETE /v1/{organizationId}/date/disable/config/batch   ==> 马光浩
    { key: 'delCsgPurchaseOrderTimeList', url: 'date/disable/config/batch', method: 'DELETE' },
    // csg采购配置明细 GET /v1/{organizationId}/date/disable/config/detail     ==> 马光浩 (没用到)
    { key: 'detCsgPurchaseOrderTimeList', url: 'date/disable/config/detail', method: 'GET' },
    // csg采购单列表
    { key: 'getCsgPurchaseOrderList', url: 'purchase/order/pageList', method: 'POST' },
    // csg 创建采购单
    { key: 'addCsgPurchaseOrder', url: 'purchase/order/add', method: 'POST' },
    // csg 采购单详情
    { key: 'getCsgPurchaseOrderDetail', url: 'purchase/order/detail', method: 'GET' },
    // csg 修改采购单
    { key: 'putCsgPurchaseOrder', url: 'purchase/order/update', method: 'POST' },
    // csg 删除采购单
    { key: 'delCsgPurchaseOrder', url: 'purchase/order/batch', method: 'DELETE' },
    // csg 新增采购收货单
    { key: 'addCsgReceivePurchaseOrder', url: 'purchase/order/addReceive', method: 'POST' },
    // csg 采购收货单列表
    { key: 'getCsgReceivePurchaseOrder', url: 'purchase/order/receiveList', method: 'GET' },
    // csg 更新采购单状态
    { key: 'updateCsgPurchaseOrder', url: 'purchase/order/updateStatus', method: 'POST' },
    // csg 获取sku list
    // url: 'purchase/order/listGoods'
    { key: 'getPurchaseOrderListGoods', url: 'purchase/order/pageListGoods', method: 'POST' },
    // csg sku尺寸校验
    { key: 'purchaseOrderGoodsSizeCheck', url: 'purchase/order/goodsSizeCheck', method: 'POST' },
    // csg  推送到仓库
    { key: 'purchaseOrderPushToHJ', url: 'purchase/order/purchase-order-manual-push-to-hj', method: 'GET' },
    // csg  入库单详情 ==》 同步到货数量  GET /v1/{organizationId}/purchase/order/purchase-order-arrival-sync
    { key: 'getPoArrivalSync', url: 'purchase/order/purchase-order-arrival-sync', method: 'GET' },
    // csg 入库单详情 ==》 修复收货数量
    { key: 'allocatePurchaseOrderPendingPool', url: 'purchase/order/pending-pool/allocate', method: 'POST', type: 'query' },
    // csg  入库单 ==》 同步状态 POST /v1/{organizationId}/purchase/order/purchase-order-push-status
    { key: 'pushPurchaseOrderStatus', url: 'purchase/order/purchase-order-push-status', method: 'POST' },
    // 获取采购订单不可用时间集合
    { key: 'getCsgPurchaseOrderUnavailableTime', url: 'purchase/order/purchase-order-unavailable-time', method: 'POST' },
    // 采购单商品barcode下载校验
    { key: 'goodsDownloadBarcodeCheck', url: 'purchase/order/goodsDownloadBarcodeCheck', method: 'POST' },

    { key: 'goodsReceivedQuantityConfirm', url: 'purchase/order/goodsReceivedQuantityConfirm', method: 'POST' },
    // 操作日志
    { key: 'getLogPage', url: '/operate-logs', method: 'GET' },
    // csg 临时存储 - 查询列表   post /v1/{organizationId}/temporary/storage/list
    { key: 'getPurchaseTemporaryList', url: 'temporary/storage/list', method: 'POST' },
    // csg 临时存储 - 新增   post /v1/{organizationId}/temporary/storage/add
    { key: 'addPurchaseTemporaryList', url: 'temporary/storage/add', method: 'POST' },
    // csg 临时存储 - 修改   post /v1/{organizationId}/temporary/storage/modify
    { key: 'modifyPurchaseTemporaryList', url: 'temporary/storage/modify', method: 'POST' },
    // 修改仓库收货备注
    { key: 'editStoreRemarks', url: 'purchase/order/updateCustomerRemarks', method: 'POST' },
    // 仓库收货备注(备注列表)   get /v1/{organizationId}/purchase/order/remarkHis
    { key: 'getStoreRemarks', url: 'purchase/order/remarkHis?id={id}', method: 'GET' },
  ],
};
export default {
  ...generate(config),
};
